import React from 'react';
import { isEmpty } from '../../helpers/util';
import { maskMoney, maskPrependComma } from '../../masks';

const DishRecipeView = props => {
  if (isEmpty(props.recipe)) return '';
  return (
    <div className="recipe">
      <div className="cms__section">
        <div className="cms__bar cms__section-head">
          <div className="cms__bar-left">
            <h3 className="h3">Recipe</h3>
          </div>
        </div>
        <div className="cms__section-body">
          {mapComponents(props.recipe)}
          <div key={'serving'} className="recipe-component">
            <p className="recipe-component__name">{`Serves: ${props.servesMin || '0'} - ${props.servesMax || '0'}`}</p>
            <p className="recipe-component__instructions"></p>
          </div>
          <div className="row row--space-between">
            <div className="row-item">
              <p className="recipe-price__label">
                Estimated Grocery Cost:{' '}
                <span className="recipe-price__label--value">
                  {maskMoney(props.price || '')}
                </span>
              </p>
            </div>
            <div className="row-item">
              <div
                className="a--blue"
                onClick={() => props.openModal('grocery-calc')}
              >
                Grocery Calculator
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapComponents = recipe => {
  if (recipe)
    return recipe.map((component, key) => renderComponent(component, key));
};

const renderComponent = (component, key) => {
  return (
    <div key={key} className="recipe-component">
      <p className="recipe-component__name">{component.name}</p>
      {mapSubcomponents(component.components)}
      {mapIngredients(component.ingredients)}
      <p className="recipe-component__instructions">{component.instructions}</p>
    </div>
  );
};

const mapSubcomponents = subcomponents => {
  if (subcomponents)
    return subcomponents.map((subcomponent, key) =>
      renderSubcomponent(subcomponent, key)
    );
};

const renderSubcomponent = (subcomponent, key) => {
  return (
    <div key={key} className="recipe-subcomponent">
      {mapSubcomponentIngredients(
        subcomponent.ingredients,
        subcomponent.instructions
      )}
    </div>
  );
};

const mapIngredients = ingredients => {
  if (ingredients)
    return (
      <div className="recipe-ingredients">
        <table>
          <tbody>
            {ingredients.map((ingredient, key) =>
              renderIngredient(ingredient, key)
            )}
          </tbody>
        </table>
      </div>
    );
};

const mapSubcomponentIngredients = (ingredients, instructions) => {
  const inst =
    instructions && instructions !== '' ? (
      <tr>
        <td></td>
        <td></td>
        <td>
          <p className="recipe-subcomponent__instructions">{instructions}</p>
        </td>
      </tr>
    ) : (
      <tr></tr>
    );
  if (ingredients)
    return (
      <table>
        <tbody>
          {ingredients.map((ingredient, key) =>
            renderIngredient(ingredient, key)
          )}
          {inst}
        </tbody>
      </table>
    );
};

const renderIngredient = (ingredient, key) => {
  return (
    <tr key={key} className="recipe-ingredient">
      <td className="recipe-ingredient__quantity">
        {ingredient.quantity || '--'}
      </td>
      <td className="recipe-ingredient__measure">
        {ingredient.measurement || ''}
      </td>
      <td className="recipe-ingredient__name">
        {ingredient.friendly_name}
        {ingredient.prep ? maskPrependComma(ingredient.prep) : ''}
      </td>
    </tr>
  );
};

export default DishRecipeView;



// WEBPACK FOOTER //
// ./src/components/dish/DishRecipeView.js